// ═══════════════════════════════════════════════════════════════════════════
// core/lib/firebaseConfig — la config WEB de cada proyecto, en una HOJA
// ═══════════════════════════════════════════════════════════════════════════
// Salió de `firebase.js` sin cambiar un valor (plan T10b v2, tajada 2): la
// página pública del evento (`src/landing/`) intercambia su token de App Check
// por REST con el `apiKey` y el `appId` de su proyecto, y no puede cargar
// `firebase.js` (arrastra el SDK entero). SIN IMPORTS a propósito.
//
// Son valores PÚBLICOS por diseño de Firebase (van en todo bundle web); lo que
// protege es App Check + las rules, no esconderlos.
// ═══════════════════════════════════════════════════════════════════════════

export const PROD_CONFIG = {
  apiKey: "AIzaSyBP0tY4vjivkvOjvQ4--LEXf8ro9f_yNJo", // gitleaks:allow — apiKey web de Firebase: pública por diseño (ver cabecera)
  authDomain: "milbrands-cowork.firebaseapp.com",
  projectId: "milbrands-cowork",
  storageBucket: "milbrands-cowork.firebasestorage.app",
  messagingSenderId: "112052922457",
  appId: "1:112052922457:web:af16d5cdf5d30ecc4ee948",
  measurementId: "G-BM57JCMNCK",
}

export const STAGING_CONFIG = {
  apiKey: "AIzaSyBWGnOTTSupqEJlq5ckMxfO_lF_9SzH3Yw", // gitleaks:allow — apiKey web de Firebase: pública por diseño (ver cabecera)
  authDomain: "milbrands-cowork-staging.firebaseapp.com",
  projectId: "milbrands-cowork-staging",
  storageBucket: "milbrands-cowork-staging.firebasestorage.app",
  messagingSenderId: "1075280472367",
  appId: "1:1075280472367:web:1837279ac326ea225499da",
  measurementId: "G-6KWBW4BTF5",
}

/** Por `projectId`: el server escribe el proyecto en la página y ella elige su config. */
export const CONFIGS = Object.freeze({
  [PROD_CONFIG.projectId]: PROD_CONFIG,
  [STAGING_CONFIG.projectId]: STAGING_CONFIG,
})
